import { render, staticRenderFns } from "./MaxOpmProgramByPeriod.vue?vue&type=template&id=13a9655e&scoped=true&"
import script from "./MaxOpmProgramByPeriod.vue?vue&type=script&lang=js&"
export * from "./MaxOpmProgramByPeriod.vue?vue&type=script&lang=js&"
import style0 from "./Ketuntasan.scss?vue&type=style&index=0&id=13a9655e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9655e",
  null
  
)

export default component.exports